import React, { useState } from "react";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";

import ChartViewSelector, { ComparePort } from "./ChartViewSelector.jsx";

import { iconSize } from "./GridRenderers.jsx";

const ChartView = ({ clientJson }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const chartCallBack = (name, args) => {
    console.log(name);
    console.log(args);
  };

  return (
    <>
      <Button variant="contained" onClick={handleShow}>
        <FontAwesomeIcon
          icon={faChartColumn}
          size={iconSize}
          // className="App-icon"
          onClick={handleShow}
        />
        Charts
      </Button>
      <ComparePort
        show={show}
        onClose={handleClose}
      >
        <ChartViewSelector
          clientJson={clientJson}
          show={show}
          onClose={handleClose}
          chartCallback={chartCallBack}
          uuids={[{ number: 1, uuid: clientJson.Scenario.uuid, label: clientJson.Scenario.label }]}
        />
      </ComparePort>
    </>
  );
};

export default ChartView;
